var React = require('react');

function ArrowNext (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Arrow","d":"M-305.61,385.78l-8,8-8-8","transform":"translate(-385.25 -305.08) rotate(-90)","fill":"none","stroke":"#253746","strokeMiterlimit":"10","strokeWidth":"1.5","opacity":"0.9"}));
}

ArrowNext.defaultProps = {"width":"9.591","height":"17.061","viewBox":"0 0 9.591 17.061"};

module.exports = ArrowNext;

ArrowNext.default = ArrowNext;
